import { Grid, TextField } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import StyledLoadingButton from './StyledLoadingButton';

/**
 * 인증번호 입력 폼
 * @param {string} labelText - placeholder(label) Text
 * @param {string} verifyButtonText - 인증 버튼 텍스트
 * @param {function} onChange - Text onChange event fun
 * @param {function} onClick - button onClick event fun
 * @param {boolean} isVerifiedAuthCode - 인증코드 검증 유무
 * @returns
 */
function AuthCodeInput({ labelText, verifyButtonText, onChange, onClick, isVerifiedAuthCode }) {
  return (
    <Grid item xs={12} style={{ display: 'flex', marginTop: '16px' }}>
      <TextField
        required
        autoFocus
        fullWidth
        id="authCode"
        name="authCode"
        label={labelText}
        onChange={onChange}
        disabled={isVerifiedAuthCode}
      />
      <StyledLoadingButton
        onClick={onClick}
        endIcon={!isVerifiedAuthCode ? <></> : <CheckCircleRoundedIcon />}
        loading={false}
        loadingPosition="end"
        variant="contained"
        disabled={isVerifiedAuthCode}
      >
        <span>{verifyButtonText}</span>
      </StyledLoadingButton>
    </Grid>
  );
}

export default AuthCodeInput;
